import { css } from 'styled-components';

export const agentWrapper = () => css`
  width: 10rem;
`;
